import { XMarkIcon } from "@heroicons/react/24/outline";
import { motion } from "motion/react";
import { LuBell, LuPlus, LuX } from "react-icons/lu";
import type { Reminder } from "../../utils/reminderUtils";

export type { Reminder };

interface RemindersSectionProps {
  displayReminders: boolean;
  setDisplayReminders: (displayReminders: boolean) => void;
  reminders: Reminder[];
  setReminders: (reminders: Reminder[]) => void;
}

export default function RemindersSection({
  displayReminders,
  setDisplayReminders,
  reminders,
  setReminders,
}: RemindersSectionProps) {
  const reminderInput = (index: number, reminder: Reminder) => {
    return (
      <div className="flex items-center gap-2">
        {/* TODO: The arrows of this onput should be hidden or redisignes*/}
        <input
          type="number"
          className="w-16 p-2 rounded-md bg-input focus:outline-none focus:ring-2 focus:ring-card border border-border placeholder:text-tertiary"
          value={reminder.number || ""}
          onChange={(e) => {
            const value = e.target.value;
            setReminders(
              reminders.map((r, i) =>
                i === index
                  ? {
                      ...r,
                      // Reminder can not be less than 0
                      number: value === "" ? 0 : Math.abs(parseInt(value)),
                    }
                  : r
              )
            );
          }}
        />
        <select
          className="w-26 p-2 rounded-md bg-input focus:outline-none focus:ring-2 focus:ring-card border border-border placeholder:text-tertiary"
          value={reminder.scale}
          onChange={(e) => {
            setReminders(
              reminders.map((r, i) =>
                i === index
                  ? { ...r, scale: e.target.value as Reminder["scale"] }
                  : r
              )
            );
          }}
        >
          <option value="minutes">Minutes</option>
          <option value="hours">Heures</option>
          <option value="days">Jours</option>
        </select>
        <div className="text-md text-primary">avant</div>
      </div>
    );
  };

  if (displayReminders) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 10 }}
        transition={{ duration: 0.3 }}
        className="border border-tertiary/20 rounded-md p-4"
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-4">
              <div className="text-lg font-medium">Rappels</div>
              <XMarkIcon
                className="text-muted h-4 w-4 cursor-pointer hover:opacity-80"
                onClick={() => {
                  setDisplayReminders(false);
                  setReminders([]);
                }}
              />
            </div>
            <div className="text-sm text-secondary">
              Déterminez quand les participants doivent être notifiés avant le
              début de l'activité.
            </div>
          </div>

          {reminders.map((reminder, index) => (
            <div key={index} className="flex items-center gap-2">
              {reminderInput(index, reminder)}
              {/* {reminders.length > 1 && ( */}
              <button
                type="button"
                onClick={() => {
                  if (reminders.length === 1) {
                    setDisplayReminders(false);
                  }
                  setReminders(reminders.filter((_, i) => i !== index));
                }}
                className="text-secondary hover:text-primary/80 transition-all duration-300 w-fit cursor-pointer"
              >
                <LuX className="w-4 h-4" />
              </button>
              {/* )} */}
            </div>
          ))}

          <button
            type="button"
            onClick={() => {
              setReminders([...reminders, { number: 10, scale: "minutes" }]);
            }}
            className="flex items-center gap-2 text-secondary hover:text-primary/80 transition-all duration-300 w-fit cursor-pointer"
          >
            <LuPlus className="w-4 h-4" />
            Ajouter un rappel
          </button>
        </div>
      </motion.div>
    );
  }

  return (
    <div
      className="flex items-center gap-2 cursor-pointer text-secondary hover:text-primary/80 transition-all duration-300"
      onClick={() => {
        setDisplayReminders(true);
        // Add a default reminder when the section is first opened
        if (reminders.length === 0) {
          setReminders([{ number: 10, scale: "minutes" }]);
        }
      }}
    >
      <LuBell className="w-4 h-4" />
      Ajouter des <span className="underline">rappels</span>
    </div>
  );
}
